import { Response } from '@angular/http';
import { isDefined } from 'ionic-angular/util/util';
import { isString } from 'util';

export const getErrorMessage = (error: string | Response | Error): string => {

    if (!error) {
        return 'UNKNOWN_ERROR';
    }

    if (isString(error)) {
        return error as string;
    }

    if (error instanceof Error || isDefined(error['message'])) {
        return error['message'];
    }

    if (error instanceof Response) {
        try {
            if (error.json().message) {
                return error.json().message;
            }
        } catch (e) {
            // noop
        }

        try {
            if (error.statusText) {
                return error.statusText;
            }
        } catch (e) {
            // noop
        }

        return error.statusText;
    }

    console.warn('Could extract error message from', error);
    return 'UNKNOWN_ERROR';
};



// WEBPACK FOOTER //
// ./src/core/util/get-error-message.ts